import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';


export const CalendarIconWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'reversed',
})<{ reversed?: boolean }>(({ reversed }) => ({
  textAlign: 'center',
  display: 'flex',
  flexDirection: reversed ? 'column-reverse' : 'column',
  alignItems: 'center',
  gap: 8,
  fontFamily: ['JetBrains Mono', 'monospace'].join(','),
  textTransform: 'uppercase',
}));

export const CalendarWeekdayPill = styled(Box)(({ theme }) => ({
  display: 'inline-block',
  borderRadius: 9999,
  padding: '4px 12px',
  fontSize: '0.875rem',
  lineHeight: 1.2,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  boxShadow: '0 6px 16px rgba(0, 0, 0, 0.35)',
}));

export const DateIconDay = styled('span')({
  display: 'block',
  fontSize: 60,
  lineHeight: '60px',
  color: '#9e9e9e',
  margin: 0,
});

export const DateIconMonth = styled('span', {
  shouldForwardProp: prop => prop !== 'reversed',
})<{ reversed?: boolean }>(({ reversed }) => ({
  background: 'linear-gradient(to top, #d10000 0%, #7a0909 60%)',
  fontSize: 18,
  lineHeight: '25px',
  fontWeight: 'bold',
  color: '#fff',
  textTransform: 'uppercase',
  display: 'block',
  padding: '6px 0',
  borderTop: reversed ? 'none' : '3px solid #a13838',
}));

export const DateIcon = styled(Box, {
  shouldForwardProp: prop => prop !== 'reversed',
})<{ reversed?: boolean }>(({ reversed }) => ({
  display: 'flex',
  flexDirection: reversed ? 'column-reverse' : 'column',
  width: 80,
  background: 'linear-gradient(to top, #fcfcfc 0%, #dad8d8 100%)',
  border: '1px solid #d2d2d2',
  borderRadius: 10,
  boxShadow: '0 12px 28px rgba(0, 0, 0, 0.35)',
  textAlign: 'center',
  overflow: 'hidden',
}));
